import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const pagesApi = createApi({
  reducerPath: 'pagesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Pages', 'Page'],
  endpoints: () => ({}),
});
